import {
    // ChevronDownIcon,
    // ChevronRightIcon,
    HomeIcon,
    // UserGroupIcon,
    // ChartBarIcon,
    CogIcon,
    // DocumentTextIcon
} from '@heroicons/react/24/outline';
import Identification from './identification';

const menuItems = [
    {
        name: 'dashboard',
        icon: <HomeIcon className="h-5 w-5" />,
        path: '/'
    },
    ...Identification,

    {
        name: 'settings',
        icon: <CogIcon className="h-5 w-5" />,
        path: '/settings',
        submenus: [
            { name: 'account', path: '/settings/account' },
            { name: 'notifications', path: '/settings/notifications' }
        ]
    }
];


export default menuItems;